namespace GeniuzPOS.InitialData {
    export class PsCustomerSurveyDtColumns {
        static columnsKey = 'InitialData.PsCustomerSurveyDt';
    }
}
